// src/apiConfig.js
// Determines the base URL for API calls in a safe, predictable way.
//
// Resolution precedence (highest first):
// 1) REACT_APP_API_URL (Create React App) or VITE_API_URL (Vite) from environment
// 2) window.REACT_APP_API_URL or window.API_URL (runtime override injected in browser)
// 3) If running in the browser and host is localhost -> http://localhost:3000
// 4) Prefer same-origin (window.location.origin) in production if available
// 5) Final fallback to a known production backend URL.
//
// The file normalizes trailing slashes so concatenation of endpoints is safe.

const PROD_BACKEND = "https://gnmc-fee-backend-production.up.railway.app";

/** Remove trailing slash(es) from a URL-like string (but keep protocol-only strings) */
function stripTrailingSlash(url) {
  if (!url || typeof url !== "string") return url;
  // Avoid stripping the trailing slash from "http://" or "https://"
  if (/^https?:\/\/$/.test(url)) return url;
  return url.replace(/\/+$/, "");
}

/** Read environment value (CRA / Vite) in a safe way */
function getEnvApi() {
  try {
    if (typeof process !== "undefined" && process.env) {
      return (process.env.REACT_APP_API_URL || process.env.VITE_API_URL || "").trim();
    }
  } catch (e) {
    // ignore
  }
  return "";
}

/** Read runtime window overrides if available */
function getWindowApi() {
  try {
    if (typeof window !== "undefined") {
      if (window.REACT_APP_API_URL && String(window.REACT_APP_API_URL).trim()) return String(window.REACT_APP_API_URL).trim();
      if (window.API_URL && String(window.API_URL).trim()) return String(window.API_URL).trim();
    }
  } catch (e) {
    // ignore
  }
  return "";
}

let API_BASE = "";

// 1) Environment variable (build-time)
const envApi = getEnvApi();
if (envApi) {
  API_BASE = envApi;
} else {
  // 2) Runtime window override
  const winApi = getWindowApi();
  if (winApi) {
    API_BASE = winApi;
  } else if (typeof window !== "undefined") {
    // 3) Running in browser
    const host = window.location && window.location.hostname ? window.location.hostname : "";
    if (host === "localhost" || host === "127.0.0.1") {
      API_BASE = "http://localhost:3000";
        } else {
      API_BASE = PROD_BACKEND;
    }
  } else {
    // 4) Non-browser (SSR / node) fallback
    API_BASE = PROD_BACKEND;
  }
}

// Final normalization: remove trailing slash
API_BASE = stripTrailingSlash(API_BASE || "");

export default API_BASE;